import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

export type ProfileStatusPopupType = 'complete_profile' | 'verification_pending' | 'verification_rejected';

@Component({
  selector: 'stupa-profile-status-popup',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './profile-status-popup.component.html',
  styleUrl: './profile-status-popup.component.scss',
})
export class ProfileStatusPopupComponent {
  @Input() visible = false;
  @Input() type: ProfileStatusPopupType = 'complete_profile';
  @Input() profileProgress = 75;

  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() editProfile = new EventEmitter<void>();
  @Output() popupClose = new EventEmitter<void>();

  onVisibleChange(value: boolean) {
    this.visible = value;
    this.visibleChange.emit(value);
    if (!value) {
      this.popupClose.emit();
    }
  }

  onEditProfileClick() {
    this.editProfile.emit();
    this.onVisibleChange(false);
  }

  closePopup() {
    this.onVisibleChange(false);
  }
}
